export const formatDate = (dateString)=>{
    const dateOnlyMatch = /^\d{4}-\d{2}-\d{2}$/.test(dateString);
    const date = dateOnlyMatch ? new Date(`${dateString}T00:00:00Z`) : new Date(dateString);
    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: dateOnlyMatch ? 'UTC' : undefined
    });
};
export const getBadgeClass = (badge)=>{
    switch(badge){
        case 'latest':
            return 'bg-green-100 text-green-800';
        case 'major':
            return 'bg-purple-100 text-purple-800';
        case 'minor':
            return 'bg-blue-100 text-blue-800';
        case 'patch':
            return 'bg-gray-100 text-gray-600';
        case 'security':
            return 'bg-red-100 text-red-800';
        default:
            return 'bg-gray-100 text-gray-600';
    }
};
export const getTagClass = (tag)=>{
    switch(tag){
        case 'core':
            return 'bg-green-100 text-green-800';
        case 'dqkd':
            return 'bg-yellow-100 text-yellow-800';
        case 'blast':
            return 'bg-purple-100 text-purple-800';
        case 'qeaas':
            return 'bg-blue-100 text-blue-800';
        default:
            return '';
    }
};
export const getTagLabel = (tag)=>{
    switch(tag){
        case 'core':
            return 'Core';
        case 'dqkd':
            return 'DQKD';
        case 'blast':
            return 'BLAST';
        case 'qeaas':
            return 'QEaaS';
        default:
            return '';
    }
};
export const getSectionTitle = (type)=>{
    switch(type){
        case 'added':
            return 'New Features';
        case 'changed':
            return 'Improvements';
        case 'fixed':
            return 'Bug Fixes';
        case 'security':
            return 'Security';
        case 'breaking':
            return 'Breaking Changes';
        default:
            return '';
    }
};
export const getSectionClass = (type)=>{
    switch(type){
        case 'added':
            return 'text-green-600';
        case 'changed':
            return 'text-blue-600';
        case 'fixed':
            return 'text-yellow-600';
        case 'security':
            return 'text-red-600';
        case 'breaking':
            return 'text-orange-600';
        default:
            return 'text-gray-600';
    }
};
export const organizeChanges = (changes)=>{
    const organized = {
        breaking: [],
        added: [],
        changed: [],
        fixed: [],
        security: []
    };
    changes.forEach((change)=>{
        if (change.type === 'breaking') {
            organized.breaking.push(change);
        } else if (change.type === 'added') {
            organized.added.push(change);
        } else if (change.type === 'changed' || change.type === 'deprecated') {
            organized.changed.push(change);
        } else if (change.type === 'fixed' || change.type === 'removed') {
            organized.fixed.push(change);
        } else if (change.type === 'security') {
            organized.security.push(change);
        }
    });
    return organized;
};
